import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TechnicalTranslatePipe } from 'app/BaseFramework/shared/custom-pipes';
import {
    ValidationUtilService,
    ApiRequestService,
    LookupDataService,
    CommonUtilty,
    I18nService,
    MultiLingualService,
    InteractService,
    ComponentOutputDO,
    AppMetadataHandler,
    CountryCityService
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { environment } from 'environments/environment';
import { PolicyService } from './../../../FunctionalModules/PolicyIssuance/policy.service';
import { AppOrganizationSettings } from './../../../BaseFramework/configs/app-organization-settings.config';
import * as html2pdf from 'html2pdf.js';

interface benefitDO {
    id: Number,
    productVersion: any,
    productCd: any,
    benefitCd: any,
    event: any,
    benefitAmt: any,
    approveAmt: any,
    decisionCd: any,
    note: any,
}


@Component({
    selector: 'underwriting-worksheet',
    templateUrl: './underwriting-worksheet.component.html',
    styleUrls: ['./underwriting-worksheet.component.scss'],    
  providers: [DatePipe, TechnicalTranslatePipe]
})
export class UnderwritingWorksheetComponent implements OnInit {
    _currentComponentName = 'UnderwritingWorksheetComponent'
    constructor(private viewContainerRef: ViewContainerRef,
        private validationUtilService: ValidationUtilService,
        private apiRequestService: ApiRequestService,
        private route: ActivatedRoute,
        private router: Router,
        private fb: FormBuilder,
        private commonUtilty: CommonUtilty,
        private i18nService: I18nService,
        private multiLingualService: MultiLingualService,
        private translateService: TranslateService,
        private lookupDataService: LookupDataService,
        private interactService: InteractService,
        public appMetadataHandler: AppMetadataHandler,
        private appOrganizationSettings: AppOrganizationSettings,
        private policyService: PolicyService,
        private datePipe: DatePipe,  
        private technicalTranslatePipe: TechnicalTranslatePipe) { }

    //Declaraions which might need developer input

    selectorOfThisComponent = 'underwriting-worksheet'
    /**
     *
     *  Ninad: Whenever any developer is creating a new Component,
     * please make sure that you copy all import commands, constructor and
     * Boiler and Component Creation Kickstart CODE 
     *
     * 
     * Component Creation Kickstart CODE 
     */


    //Initializations
    selectedpolicy: any;
    selectedPolicyDO : any;
    selectPolNum: any;
    private _IO = null;
    private DO = null;
    public proposalIO = null;
    parentEvent$
    ownerClientDO: any;
    insuredList = [];

    emptyBenfitDO: benefitDO = {
        id: null,
        productVersion: null,
        productCd: null,
        benefitCd: null,
        event: null,
        benefitAmt: null,
        approveAmt: null,
        decisionCd: null,
        note: null
    }
    //ComponentSpecific Inputs, Outputs 
    @Output() componentOutput = new EventEmitter<any>();
    @Input() transactionState: string;
    @Input() enableDownload : boolean = true;
    @Input() enableLogo : boolean = true;
    @Input()
    set IO(value: any) {
        console.log("io in underwriting worksheet", JSON.stringify(value));
        this._IO = value;
        //this.lifeInsured = value;
        if (this._IO != null) {
            this.getDOAndSetPolicy();
            this.proposalIO = this.getDOName(this._IO);
            console.log("policy IO in underwriting worksheet", JSON.stringify(this.proposalIO));
        }

    };

    getDOName(IO) {
        console.log(IO)
        if (IO)
            return IO['intimationDO'] || IO['claimDO'] || IO['adjudicationDO'] || IO['investigationDO'] || IO['proposalDO'] || IO['caseDO'];
        else
            null
    }


    private getDOAndSetPolicy() {
        // this.DO = this.getPolicyDO(this._IO);
        // this.DO = this._IO["caseDO"];
        // if (this.DO != null) {
        //     let anyPolicy = this.DO.find(item => true)
        //     if (anyPolicy)
        // this.selectPolNum = this._IO["caseDO"]['proposalNum'];
        // this.selectedpolicy = this.findPolicyByNum(this.selectPolNum);
        let ownerClient: any
        this.selectedpolicy = this._IO;
        if (this.selectedpolicy && this.selectedpolicy.proposalDO) {
            this.selectedPolicyDO = this.selectedpolicy.proposalDO
            if (this.selectedpolicy.proposalDO.proposalClients && this.selectedpolicy.proposalDO.proposalClients.length && this.selectedpolicy.proposalDO.proposalClients.length > 0)
                ownerClient = this.selectedpolicy.proposalDO.proposalClients.find(item => item.roleCd === 'OWNER');
        } else if (this.selectedpolicy && this.selectedpolicy.caseDO){
            this.selectedPolicyDO = this.selectedpolicy.caseDO
            if (this.selectedpolicy.caseDO.caseClients && this.selectedpolicy.caseDO.caseClients.length && this.selectedpolicy.caseDO.caseClients.length > 0)
                ownerClient = this.selectedpolicy.caseDO.caseClients.find(item => item.roleCd === 'OWNER')
        }

        if (ownerClient)
            this.ownerClientDO = this.selectedpolicy.clientDOs.find(item => item.guid === ownerClient.clientRefGuid)
        // this.getOwnerName();
        console.log("selected policy data", JSON.stringify(this.selectedpolicy));

        // }
    }

    get IO() {
        return this._IO;
    }


    getPolicyDO(IO) {
        let output = null
        if (IO != null) {
            switch ("policy") {
                case "policy": {
                    if (IO['intimationDO'] || IO['claimDO'] || IO['investigationDO'] || IO['caseDO']) {
                        if (IO['intimationDO'])
                            output = IO['intimationDO']['policies']

                        if (IO['claimDO']) {
                            output = IO['claimDO']['policy']

                        }
                        if (IO['investigationDO'])
                            output = IO['investigationDO']['policy']

                        if (IO['caseDO'])
                            output = IO['caseDO']['policy']

                        break;
                    }
                }
                default: {
                    console.log("Invalid choice");
                    break;
                }
            }
        }

        return output
    }



    EmitComponentOutput(data) {
        let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
    }
    getParentComponent(): Component {
        try {
            return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
        } catch { }
    }
    getParentComponentName(): string {
        try {
            return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
        } catch { }
    }
    getCurrentComponentName(): string {
        return this._currentComponentName
    }

    subscribeToParentEvent() {
        if (this.parentEvent$ != null)
            this.parentEvent$.unsubscribe()
        this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
            this.EmitComponentOutput(null);
        })
    }


    organizationMetaData: any;
    ngOnInit() {
        const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
        if (environment && !environment.production) {
            console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
            console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
            console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
            console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
            console.groupEnd();

        }

        this.organizationMetaData = this.appOrganizationSettings.getOrganizationMetaData();
        this.subscribeToParentEvent();

        this.getClientsForEveryRole(this.IO)
        this.initializeCoverages(this.IO)
        this.initializeInsuredList(this.IO)
        // let otherListNode = configData.OtherListNodeMapper[this.transactionState]
        let DO = this.getDOName(this.IO);
        if(this.IO && this.IO['caseDO'] && this.IO['caseDO']['othercases'])
            this.otherPolicyList = this.IO['caseDO']['othercases'] ? this.IO['caseDO']['othercases'] : this.IO['proposalDO']['otherProposals'];
        this.generateUnderwritingSummary();
    }


    findPolicyByNum(proposalNum) {
        let output = {}
        if (proposalNum) {
            this.selectPolNum = proposalNum;
            this.policyService.getPolicyByPolicyNum(this.selectPolNum).subscribe(resp => {
                this.selectedpolicy = resp;
                // this.getOwnerName();

                console.log("selected policy", JSON.stringify(this.selectedpolicy));
                output = this.selectedpolicy;
            },
                (error) => {
                    throw " Something went wrong";
                }
            );

        }
        else {
            output = this.DO.find(item => true) || []
        }

        console.log("=========================", output);
        return output;

    }

    getDateString(rawDate) {
        let dateString
        if (rawDate != null) {
            dateString = moment(rawDate).format('DD MMM YYYY');
        }
        else {
            dateString = '-'
        }
        return dateString
    }

    listOfinsured: any[] = [];
    listOfPrimaryInsured: any[] = [];
    nomineelist: any[] = [];
    payerList: any[] = [];

    getClientsForEveryRole(IO) {
        this.listOfPrimaryInsured = this.commonUtilty.extractClientDOFromIOGeneric(IO, 'PRIMARYINSURED');
        this.listOfinsured = this.commonUtilty.extractClientDOFromIOGeneric(IO, 'INSURED')
        console.log("insured list", JSON.stringify(this.listOfinsured));
        this.nomineelist = this.commonUtilty.extractClientDOFromIOGeneric(IO, 'NOMINEE')
        this.payerList = this.commonUtilty.extractClientDOFromIOGeneric(IO, 'PAYER')
    }

    benefitList: any[] = []
    otherPolicyList: any[] = [];
    finalDecisionList: any[] = [];
    coveragesDecisionList: any[] = [];
    UICoverageInsuredNodeName = "coverageInsuredListMap"

    private initializeCoverages(IO) {
        if (IO) {
            // this.tempInsuredList = this.getAllInsuredsFromIO(IO);
            let DO = this.commonUtilty.getDO(IO);
            this.coveragesDecisionList = this.commonUtilty.deepCopy(DO['caseCoverages']) || this.commonUtilty.deepCopy(DO['proposalCoverages']) || [];
            this.coveragesDecisionList.forEach(coverage => {
                let coverageInsuredList = coverage['caseCoverageInsureds'] || coverage['proposalCoverageInsureds']
                coverage[this.UICoverageInsuredNodeName] = this.commonUtilty.convertArrayToMap(coverageInsuredList, 'clientId');
            });
        }
    }

    getPolicyOwenerName: any;
    getOwnerName() {
        let proposalNum = null
        if (this.selectedpolicy && this.selectedpolicy['caseDO'] != null && this.selectedpolicy['caseDO'].length > 0)
            proposalNum = this.selectedpolicy['caseDO']['proposalNum'] ? this.selectedpolicy['caseDO']['proposalNum'] : '';
        let filterOutput = null;
        let output = {}
        let ownerRefGuid;
        let name = null;
        if (this.selectedpolicy != null && Object.keys(this.selectedpolicy).length && proposalNum) {
            let clientDO = this.selectedpolicy['clientDOs'];
            if (this.selectedpolicy.caseDO && this.selectedpolicy.caseDO.caseClients != null) {

                ownerRefGuid = this.selectedpolicy.caseDO.caseClients.find(item => {
                    if (item.roleCd == "OWNER") {
                        clientDO.filter(ele => {
                            if (ele['guid'] == item.clientRefGuid) {
                                filterOutput = ele['personDO']['firstName'] + ' ' + ele['personDO']['lastName']
                            }
                        })
                    }
                })

            }

        }


        this.getPolicyOwenerName = filterOutput ? filterOutput : '-';


    }

    initializeInsuredList(IO) {
        if (IO)
            this.insuredList = this.getAllInsuredsFromIO(IO);

        console.log("insured list", JSON.stringify(this.insuredList));
    }

    getAllInsuredsFromIO(IO) {
        let output = []
        if (IO) {
            let PRIMARYINSUREDLIST = this.commonUtilty.extractClientDOListFromIOGeneric(IO, 'PRIMARYINSURED');
            let INSUREDLIST = this.commonUtilty.extractClientDOListFromIOGeneric(IO, 'INSURED');
            if (PRIMARYINSUREDLIST && Array.isArray(PRIMARYINSUREDLIST))
                output.push(...PRIMARYINSUREDLIST);
            if (INSUREDLIST && Array.isArray(INSUREDLIST))
                output.push(...INSUREDLIST)
        }
        return output
    }

    downloadPDF()  {
    const options = {
      margin: 10,
      filename: "worksheet.pdf",
      image: {type: 'jpeg'},
      html2canvas:{},
      jsPDF:{orientation: 'Portrait'}
    };
    const content: Element= document.getElementById('uwWorksheetSection');
    html2pdf()
      .from(content)
      .set(options)
      .save();
  }

  underwritingSummary : string;
  generateUnderwritingSummary(){
    let caseDO = this.IO['caseDO'];
    if(caseDO){
    let req_payload = {
        "product_type": "LIFE_Claims_Dev",
        "business_process": "FWARISKANALYSIS",
        "module_name": "VisionIntelligence",
        "outputLang":"ENGLISH",
        "input_data":{
            "LOB": caseDO['baseProductFamilyCd'],
            "proposalNum": caseDO['proposalNum'],
            "baseProductCd": this.technicalTranslatePipe.transform(caseDO['baseProductCd']),
            "proposalSignedDate": caseDO['proposalSignedDt'] ? this.getDateData(new Date(caseDO['proposalSignedDt'])) : null,
            "proposalReceivedDate": caseDO['proposalReceivedDt'] ? this.getDateData(new Date(caseDO['proposalReceivedDt'])) : null,
            "policyCommencementDt": caseDO['policyCommencementDt'] ? this.getDateData(new Date(caseDO['policyCommencementDt'])) : null,
            "policyExpiryDt": this.getExpiryDate(caseDO['policyCommencementDt'], caseDO['policyExpiryDt'], caseDO['policyTerm']),
            "sumInsured": caseDO['sumInsuredAmt'],
            "finalPremiumAmt": caseDO['finalPremiumAmt'],
            "policyTerm": caseDO['policyTerm'] || 1,
            "policyHolder": this.commonUtilty.getFirstNameFromClient(this.ownerClientDO) || '' + " " + (this.commonUtilty.getLastNameFromClient(this.ownerClientDO) || ''),
            "primaryInsured" : this.fetchClientList('PRIMARYINSURED'),
            "insuredList": this.fetchClientList('INSURED'),
            "nomineeList": this.fetchClientList('NOMINEE'),
            "payerList": this.fetchClientList('PAYER'),
            "otherPolicyList" : this.otherPolicyList,
            "coverageList": this.fetchCoverageData()
        }
    }

    this.multiLingualService.generateSummaryForUnderwriting(req_payload).subscribe(resp => {
        this.underwritingSummary = resp.underWriterSummary;
        
      }, (e) => {
        console.log("error captured  for generating underwriting summary: ", e);
      })
    }
  }

  getDateData(dateValue){
    return this.datePipe.transform(dateValue, 'dd/MM/yyyy');
  }

  getExpiryDate(startDate, expiryDate, term) {
    if (expiryDate) {
      return this.getDateData(new Date(expiryDate))
    } else if (startDate) {
      let diff = term || 1;
      let date = new Date(startDate);
      date.setFullYear(date.getFullYear() + diff);
      return  this.getDateData(date)
    } else {
      return null;
    }
  }

  fetchClientList(roleType){
    let clientList = [];
    let extractedClientData = this.commonUtilty.extractClientDOFromIOGeneric(this.IO, roleType);
    if(this.commonUtilty.isArrayIterable(extractedClientData)){
        extractedClientData.forEach(client =>{
            let tempObj = {
                "name": client.nameWithSalutation || client.name,
                "dateOfBirth": client.dateOfBirth,
                "contactNum": client.preferredMobileNum || client.clientContactDetailsList &&  client.clientContactDetailsList.length > 0 ? client.clientContactDetailsList[0].contactNum : null,
                "address": client.preferredAddress
            }
            clientList.push(tempObj);
        });
    }
    return clientList;
  }

  fetchCoverageData(){
    let covList = [];
    if(this.commonUtilty.isArrayIterable(this.coveragesDecisionList)){
        this.coveragesDecisionList.forEach(cov => {
            let tempObj = {
                "productCd": this.technicalTranslatePipe.transform(cov.productCd),
                "sumInsured": cov.sumInsured,
                "totalPremiumAmt": cov.totalPremiumAmt
            }
            covList.push(tempObj);
        })
    }
    return covList;
  }

}
